// loads scripts that need to be on page - every entrypoint should import this!
import { findElementByIdInShadowDom } from './utils/render.js';

import { renderShapesMap } from './shapesMap.js';

const mapElement = findElementByIdInShadowDom('map');

async function main() {
  renderShapesMap(mapElement);
}

main().catch(console.error);
